import gsap from "gsap";

import SplitText from "gsap/dist/SplitText";
import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";

gsap.registerPlugin(SplitText);

document.querySelectorAll(".js-process").forEach((el) => {
	const steps_el = el.querySelectorAll(".js-process-step"),
		progress_bar_el = el.querySelector(".js-progress-bar"),
		numbers_el = el.querySelector(".js-counter-wrapper"),
		subtitle_el = el.querySelector(".js-subtitle-wrapper"),
		steps_container_el = el.querySelector(".js-steps-container");

	let currentStep = 0;

	let totalSteps = steps_el.length;
	let isAnimating = false;

	const splitContent = [];

	const arrows = el.querySelectorAll(".js-process-slider-control");

	// initial progress

	gsap.to(progress_bar_el, {
		scaleX: parseFloat(1 / totalSteps),
	});

	const changeStep = (direction) => {
		isAnimating = true;

		// adjust container height




		let nextStep = currentStep;
		const wrappingForward = nextStep + direction === totalSteps;

		if (wrappingForward) {
			nextStep = 0;
		} else if (currentStep + direction < 0) {
			nextStep = totalSteps - 1;
		} else {
			nextStep += direction;
		}

		gsap.to(steps_container_el, {
			height: steps_el[nextStep].offsetHeight,
			delay: 0.3,
		});

		gsap.to(splitContent[currentStep].lines, {
			y: "-100%",
			opacity: 0,
			stagger: 0.025,
			onComplete: () => {
				// hiding the current step
				steps_el[currentStep].classList.add(
					"opacity-0",
					"absolute",
					"pointer-events-none",
				);

				// update current step

				currentStep = nextStep;

				// show next step?

				steps_el[currentStep].classList.remove(
					"opacity-0",
					"absolute",
					"pointer-events-none",
				);

				gsap.fromTo(
					splitContent[currentStep].lines,
					{
						y: "-100%",
						opacity: 0,
					},
					{
						y: 0,
						opacity: 1,
						stagger: 0.025,
						onComplete: () => {
							steps_container_el.style.height = "auto";
							isAnimating = false;
						},
					},
				);

				// line scaling

				let scale = (1 / totalSteps) * (currentStep + 1);

				gsap.to(progress_bar_el, {
					scaleX: parseFloat(scale),
				});

				// subtitle & numbers progress

				if (wrappingForward) {
					gsap.to(subtitle_el, {
						y: -1.5 * totalSteps + "rem",
						onComplete: () => gsap.set(subtitle_el, { y: "0rem" }),
					});

					gsap.to(numbers_el, {
						y: -0.875 * totalSteps + "rem",
						delay: 0.1,
						onComplete: () => gsap.set(numbers_el, { y: "0rem" }),
					});
				} else {
					gsap.to(subtitle_el, {
						y: -1.5 * currentStep + "rem",
					});

					gsap.to(numbers_el, {
						y: -0.875 * currentStep + "rem",
						delay: 0.1,
					});
				}
			},
		});
	};

	arrows.forEach((arrow) => {
		arrow.addEventListener("click", () => {
			let direction = parseInt(arrow.getAttribute("data-direction"));

			let arrowContainer = arrow.querySelector(".js-arrow-animation");

			if (!isAnimating) {
				gsap.fromTo(
					arrowContainer,
					{
						x: direction == 1 ? 0 : "-50%",
					},
					{
						x: direction == 1 ? "-50%" : 0,
					},
				);

				changeStep(direction);
			}
		});
	});

	// gsap.set(".split", { opacity: 1 });

	steps_el.forEach((el) => {
		let split = SplitText.create(el.querySelectorAll(".split"), {
			type: "words,lines",
			linesClass: "line",
			autoSplit: true,
			mask: "lines",
		});

		splitContent.push(split);
	});

	// on scroll animation

	initOnScrollAnimation(el);
});
